import React, { useEffect, useState } from 'react';
import Tabs from 'cccisd-tabs';
import { client } from 'cccisd-apollo';
import Loader from 'cccisd-loader';

import JobTable from './JobTable';
import DeployTable from './DeployTable';
import BuildsTable from './BuildsTable';
import deploymentQuery from './deployments.graphql';

const Fortress = window.cccisd.fortress;

import { renderAlert } from '../dashboardHelpers';

const DevOps = () => {
    const [hasDevOps, setHasDevOps] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getPermissions() {
        const response = await client.query({
            query: deploymentQuery,
            fetchPolicy: 'network-only',
        });
        const groupId = response.data.flows.deployment.assignment.groupId;
        setHasDevOps(Fortress.hasAccess('quest.view_identifiable_data', groupId));

        setIsLoading(false);
    }

    useEffect(() => {
        getPermissions();
    }, []);

    const tabs = [
        { name: 'deploy', title: 'Deploy', content: <DeployTable /> },
        { name: 'jobs', title: 'Jobs', content: <JobTable /> },
        { name: 'builds', title: 'Builds', content: <BuildsTable /> },
    ];

    if (!isLoading && !hasDevOps) {
        return renderAlert('No DevOps permissions found for your account.');
    }

    return (
        <Loader loading={isLoading} removeChildren>
            {!isLoading && <Tabs tabList={tabs} />}
        </Loader>
    );
};

export default DevOps;
